import React, {Component, ReactNode} from 'react';

interface Props {
    enabled: boolean
    onClick: () => void
}

export default class PokerMenuButtonSound extends Component<Props> {
    render(): ReactNode {
        return <button className="poker-menu-container-button audio" onClick={this.props.onClick}>
            <svg className="svg-default">
                <use xlinkHref={this.props.enabled ? '#svg-volume0' : '#svg-volume70more'}/>
            </svg>
        </button>;
    }
}
